module.exports = __webpack_public_path__ + "a3fbf4f885586f7676c5623400447cdd.pdf";